import React from "react";
import { Link } from "react-router-dom";
import  SliderDashboard  from './sliderDashboard';
 // import logo from "../../img/logo/logoImg-removebg-preview.png";
import logo from "../../img/logo-conga.svg";
// import MyMenu from '../../components/dashboard/component/mymenu';
import {withRouter} from 'react-router-dom';
// import slider from "../../../img/logo/sliderConga.png";
// import slider from "../../img/logo/sliderConga.png";
import {version, RELEATIVE_PATH} from '../../config';


const Header = (props) => {
  let removePath =props.location.pathname.replace(RELEATIVE_PATH,"");
  let title=removePath.replace(/\//g,"");

  title=title.includes('upgrade-status')?'upgrade-status':title;
  let allTitle={
    'dashboard':"Dashboard",
    'aa':'Welcome to Conga Automation Framework Dashboard',
    'upgrade-status':' Test Automation Dashboard for the Conga Upgrade Services',
    'quintessential-status' :'Quintessential Status',
    'automation-execution' :'Conga Services Test Automation Execution Page',
    'test-repository':' Please select a criterion to list the tests',
    'code-builder':'Advanced Scripting Editor',
    'reference-library':' Please select an existing class to view the code',
    'community':'Community Dashboard',
    'conga-login':'Welcome To Conga Automation Framework Portal',
    '':'Welcome to Conga Automation Framework Portal',
    'user-settings':'User Settings',
    'ae':"Automation Page",
    'customer':"Welcome to Conga Automation Early Feedback Program",
    'customer-process':"Do Things Have To End?",
    'salesforce-login':'Failure Triaging Program',
    'salesforce-opt':"Do Things Have To Come To End Already?"
  }
  return (
    <>
  { title!=="dashboard"  && <header>
      <Link to={`${RELEATIVE_PATH}`}>
        <img
          src={logo}
          alt="HomePage"
          className="navbar-brand"
          style={{ width: "50%", padding:0, margin:0 }}
        ></img>
      </Link>
      {/* <div className="versionApp">{version}</div> */}
    
      <div className="header-title">{allTitle[title]} </div>
      
      </header>}
      { title==="dashboard"  &&  <div  className="container-fuild slider"> <SliderDashboard/></div>}



    </>
  );
}
export default withRouter(Header);
